var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0249 23.2749L8.6499 19.9999H3.9999V15.3499L0.649902 11.9999L3.9999 8.6499V3.9999H8.6499L12.0249 0.649902L15.3499 3.9999H19.9999V8.6499L23.3499 11.9999L19.9999 15.3499V19.9999H15.3499L12.0249 23.2749ZM12.0249 21.1749L14.7228 18.4999H18.4999V14.7249L21.2249 11.9999L18.4999 9.2749V5.4999H14.7249L12.0249 2.7749L9.2749 5.4999H5.4999V9.2749L2.7749 11.9999L5.4999 14.7249V18.4999H9.2499L12.0249 21.1749ZM9.0749 16.2499L11.9999 14.4749L14.9249 16.2499L14.1499 12.9249L16.7499 10.6749L13.3249 10.3999L11.9999 7.2499L10.6749 10.3999L7.2499 10.6749L9.8499 12.9249L9.0749 16.2499Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVehicles);
export default __webpack_public_path__ + "static/media/new_vehicles.11c98d92e8b6feb51d44e6acab347dea.svg";
export { ForwardRef as ReactComponent };